import Vue from 'vue'
import Vuex from 'vuex'
import {
    SITE_BASE_URL,
    ADMIN_BASE_URL,
    BASE_URL,
    ASSETS_BASE_URL,
    ASSETS_VIDEO_BASE_URL,
    GOOGLE_API_KEY,
    GOOGLE_MAP_KEY,
    STREAMING_CDN_SERVER_BASE_URL,
    WEBRTC_STREAMING_SERVER_BASE_URL
} from "./variables";
import User from './modules/user.js'
import Upload from './modules/upload.js'
import Channel from "./modules/channel.js"
import Streaming from "./modules/streaming.js"
import Reporting from "./modules/reporting.js"
import SupportChat from "./modules/support_chat.js"
import Finance from "./modules/finance.js"
import Settings from "./modules/settings.js"
import Pricing from "./modules/pricing.js"
import Ads from "./modules/ads.js"
import Voting from "./modules/voting.js"
import Events from "./modules/events"
import Customizations from "./modules/customizations"
import Blogs from './modules/blogs';
import WebStatic from './modules/webStatic';
import audvisual from './modules/audvisual';
import Donation from "./modules/donation.js";
import Payment from "./modules/payment.js";

Vue.use(Vuex)
export default new Vuex.Store({
    state: () => ({
        sidebar: true,
        eventBus: new Vue(),
        access_token: null,
        ADMIN_BASE_URL: ADMIN_BASE_URL,
        BASE_URL: BASE_URL,
        ASSETS_BASE_URL: ASSETS_BASE_URL,
        ASSETS_VIDEO_BASE_URL: ASSETS_VIDEO_BASE_URL,
        GOOGLE_API_KEY: GOOGLE_API_KEY,
        GOOGLE_MAP_KEY: GOOGLE_MAP_KEY,
        STREAMING_CDN_SERVER_BASE_URL: STREAMING_CDN_SERVER_BASE_URL,
        SITE_BASE_URL: SITE_BASE_URL,
        STREAMING_CDN_SERVER_BASE_URL: STREAMING_CDN_SERVER_BASE_URL,
        WEBRTC_STREAMING_SERVER_BASE_URL: WEBRTC_STREAMING_SERVER_BASE_URL,
        main_loader: false,
    }),
    mutations: {
        ["SET_TOKEN"]: (state, payload) => {
            state.access_token = payload;
        },
        ["START_LOADER"]: (state) => {
            state.main_loader = true;
        },
        ["STOP_LOADER"]: (state) => {
            state.main_loader = false;
        },
        ["TOGGLE_SIDE_BAR"]: (state, payload) => {
            state.sidebar = payload;
        },
        ["SET_WEB_SITE_BASE_URL"]: (state, payload) => {
            if (process.env.NODE_ENV != 'development' && payload != null && payload != undefined && payload != "" && payload != "https:///") {
                state.SITE_BASE_URL = payload ? payload : SITE_BASE_URL;
            }
        }
    },
    getters: {
        getUserAccessToken(state) {
            return state.access_token;
        }
    },
    actions: {
        ["TOGGLE_SIDE_BAR"]: ({ state, commit }, payload) => {
            commit("TOGGLE_SIDE_BAR", !state.sidebar);
            Vue.localStorage.set("is_sidebar", state.sidebar);
        }
    },
    modules: {
        User,
        Upload,
        Channel,
        Streaming,
        Reporting,
        SupportChat,
        Finance,
        Settings,
        Pricing,
        Ads,
        Voting,
        Events,
        Customizations,
        Blogs,
        WebStatic,
        audvisual,
        Donation,
        Payment
    }
})